import React, { Component } from 'react';
import '../../App.css';
import Slider from "react-slick";
import FlipPage from 'react-flip-page'

import Footer from '../reusables/footer'

import BananoThumb from '../../img/pioricost-fruit/banano/banano1.jpeg'

import Banano2 from '../../img/pioricost-fruit/banano/banano2.jpeg'
import Banano4 from '../../img/pioricost-fruit/banano/banano4.jpeg'
import Banano5 from '../../img/pioricost-fruit/banano/banano5.jpeg'

import Pit1 from '../../img/pioricost-fruit/pitahaya/pit1.jpeg'
import Pit2 from '../../img/pioricost-fruit/pitahaya/pit2.jpeg'
import Pit3 from '../../img/pioricost-fruit/pitahaya/pit3.jpeg'
import Pit4 from '../../img/pioricost-fruit/pitahaya/pit4.jpeg'

import Cacao1 from '../../img/pioricost-fruit/cacao/cacao1.jpeg'
import Cacao2 from '../../img/pioricost-fruit/cacao/cacao2.jpeg'
import Cacao3 from '../../img/pioricost-fruit/cacao/cacao3.jpeg'
import Cacao4 from '../../img/pioricost-fruit/cacao/cacao4.jpeg'

import cert1 from '../../img/pioricost-fruit/certificaciones/1.jpg'
import cert2 from '../../img/pioricost-fruit/certificaciones/2.png'
import cert3 from '../../img/pioricost-fruit/certificaciones/3.png'
import cert4 from '../../img/pioricost-fruit/certificaciones/4.png'

import revista1 from '../../img/magazine/1.jpg'
import revista2 from '../../img/magazine/2.jpg'
import revista3 from '../../img/magazine/3.jpg'
import revista4 from '../../img/magazine/4.jpg'
import revista5 from '../../img/magazine/5.jpg'
import revista6 from '../../img/magazine/6.jpg'
import revista7 from '../../img/magazine/7.jpg'
import revista8 from '../../img/magazine/8.jpg'

import flipSound from '../../audio/flip.mp3'

class Fruit extends Component {
    constructor(){
        super()
        this.state = {
            showItem : 1,
            widthMagazine: 600,
            heightMagazine: 800
        }
    }

    componentDidMount(){
        if( /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent) ) {
            // console.log("este es un smartphone")
            this.setState ({ widthMagazine: 380 })
            this.setState ({ heightMagazine: 510 })
         } else {
            this.setState ({ widthMagazine: 600 })
            this.setState ({ heightMagazine: 800 })
         }
    }

    showCaja=(producto)=>{
        this.setState({
            showItem: this.state.showItem ? 0 : producto
        })
    }
    
  render() {
      var settings = {
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 2000,
        fade: true,
        arrows: false
      }
    return (
      <div className="Fruit">
        <br/><br/><br/>
        <br/><br/><br/>
        <br/><br/><br/>
            <div className="magazine">
            <audio id="audioContainer" volume="0.2">
              <source src={flipSound} type="audio/mp3"/>
            </audio>
            <FlipPage width={this.state.widthMagazine} height={this.state.heightMagazine} orientation="horizontal"
                        onPageChange={()=>{document.getElementById("audioContainer").play()}} >
                <img src={revista1} />
                <img src={revista2} />
                <img src={revista3} />
                <img src={revista4} />
                <img src={revista5} />
                <img src={revista6} />
                <img src={revista7} />
                <img src={revista8} />
            </FlipPage>
            </div>
            <div className="main-container-product" id="">
                <div className="slider-product-container">
                <Slider {...settings}>
                    <div>
                    <img src={BananoThumb} alt=""/>
                    </div>
                    <div>
                    <img src={Banano2} alt=""/>
                    </div>
                    <div>
                    <img src={Banano4} alt=""/>
                    </div>
                    <div>
                    <img src={Banano5} alt=""/>
                    </div>
                </Slider>                       
                </div>
                <div className="info-product">
                    <span>BANANA</span><hr/>
                    <p>
                        <b>FEATURES</b><br/><br/>
                        <b>Finger size:</b> 18 cm minimum<br/>
                        <b>Size:</b> Minimum 39 mm Maximum 47 mm<br/>
                        <b>Class:</b> "A" Premium<br/>
                        <b>Age of the fruit:</b> Minimum 10 weeks and maximum 13 weeks
                        <br/><br/>
                        <b>HARVESTING PERIOD</b><br/><br/>
                        All year round<br/><br/>

                        <b>PACKAGING</b><br/><br/>
                        <b>Box type 208 (Asia)</b><br/>
                        <b>Finger size:</b> 18 cm minimum<br/>
                        <b>Number of fingers per hand:</b> 15 Minimum<br/>
                        <b>Size:</b> Minimum 39 mm Maximum 47 mm<br/>
                        <b>Age of the fruit:</b> Minimum 10 weeks and maximum 13 weeks. Boxes: Type 208 boxes (13.6 kg net), box in hands 1,500 boxes in bulk container. <br/>
                        <b>Packing:</b> Lid, bottom, outer cardboard, inner cardboard, protector between hands and vacuum or polytube cover.<br/><br/>


                        <b>Box type 22XU (Europe and USA)</b><br/><br/>
                        <b>Finger size:</b> 18 cm minimum<br/>
                        <b>Size:</b> Min. 39 mm Max. 46 mm.<br/>
                        <b>Number of fingers per hand:</b> Min. 5 to max. 12 fingers<br/>
                        <b>Boxes:</b> 22XU type boxes (18.14 Kg net or 19.45 Kg net) 960 or 1,080 boxes in a palletized container.<br/>
                        <b>Packaging:</b> lid, bottom, cardboard and vacuum or polypack sleeve.<br/>
                    </p>
                </div>
            </div>
            <div className="valor-nutricional">
                <span>NUTRITION <b>VALUE</b></span><br/><br/>
                <div className="cuadros-vn">
                    <div className="cuadro">
                        <label>Calorías</label>
                        <span>110,5 kcal</span>
                    </div>
                    <div className="cuadro">
                        <label>Vitamina B6</label>
                        <span>0,68 mg</span>
                    </div>
                    <div className="cuadro">
                        <label>Hidratos de<br/> Carbonos</label>
                        <span>26,2 g</span>
                    </div>
                    <div className="cuadro">
                        <label>Potasio</label>
                        <span>467 mg</span>
                    </div>
                    <div className="cuadro">
                        <label>Grasas</label>
                        <span>-1 g</span>
                    </div>
                    <div className="cuadro">
                        <label>Proteínas</label>
                        <span>1,2 g</span>
                    </div>
                    <div className="cuadro">
                        <label>Vitamina C</label>
                        <span>18 mg</span>
                    </div>
                    <div className="cuadro">
                        <label>Fibra<br/> Alimentaria</label>
                        <span>2,6 g</span>
                    </div>
                    <div className="cuadro">
                        <label>Fósforo</label>
                        <span>38,7 mg</span>
                    </div>
                    <div className="cuadro">
                        <label>Magnesio</label>
                        <span>41,5 mg</span>
                    </div>
                </div>
            </div>     
        {/* } */}
        
        <br/><br/><br/>
        {/* {this.state.showItem === 2 && */}
            <div className="main-container-product" id="">
            <div className="slider-product-container">
            <Slider {...settings}>
                <div>
                <img src={Pit1} alt=""/>
                </div>
                <div>
                <img src={Pit2} alt=""/>
                </div>
                <div>
                <img src={Pit3} alt=""/>
                </div>
                <div>
                <img src={Pit4} alt=""/>
                </div>
            </Slider>                       
            </div>
            <div className="info-product">
                <span>PITAHAYA</span><hr/>
                <p>
                    <b>FEATURES</b><br/><br/>
                    It is an ovoid shaped fruit, elongated from 10 to 15 cm in diameter, has yellowish skin, the pulp is white with numerous small black seeds, its weight ranges from 350 gm to 450 grams.
                    <br/><br/>
                    <b>HARVESTING PERIOD</b><br/><br/>
                    It has three major harvesting periods:<br/>
                    • December to March<br/>
                    • October to November<br/>
                    • May to June<br/>
                    <br/><br/>

                    <b>PACKAGING</b><br/><br/>
                    The fresh fruit is packed in cardboard boxes, where the number of units and the net weight are detailed. Each box contains 5 to 7 units of fruit, with a net weight of 2.5 kilos.<br/>
                </p>
            </div>
        </div>
        <div className="valor-nutricional">
                <span>VALOR <b>NUTRICIONAL</b></span><br/><br/>
                <label>Pitahaya Amarilla</label><br/><br/>
                <div className="cuadros-vn">
                    <div className="cuadro">
                        <label>Valor energético</label>
                        <span>54 kcal</span>
                    </div>
                    <div className="cuadro">
                        <label>Grasa</label>
                        <span>0,4 g</span>
                    </div>
                    <div className="cuadro">
                        <label>Carbohidratos</label>
                        <span>15 g</span>
                    </div>
                    <div className="cuadro">
                        <label>Proteína</label>
                        <span>1,2 g</span>
                    </div>
                    <div className="cuadro">
                        <label>Fibra cruda</label>
                        <span>0,8 g</span>
                    </div>
                    <div className="cuadro">
                        <label>Fósforo</label>
                        <span>16 mg</span>
                    </div>
                    <div className="cuadro">
                        <label>Vitamina A</label>
                        <span>5 ug</span>
                    </div>
                    <div className="cuadro">
                        <label>Vitamina C</label>
                        <span>8 mg</span>
                    </div>
                    <div className="cuadro">
                        <label>Niacina</label>
                        <span>0,36 mg</span>
                    </div>
                </div>
            </div>   
            <div className="valor-nutricional"><br/>
                {/* <span>VALOR <b>NUTRICIONAL</b></span><br/> */}
                <label>Pitahaya Morada</label><br/><br/>
                <div className="cuadros-vn">
                <div className="cuadro">
                        <label>Valor energético</label>
                        <span>54 kcal</span>
                    </div>
                    <div className="cuadro">
                        <label>Grasa</label>
                        <span>0,4 g</span>
                    </div>
                    <div className="cuadro">
                        <label>Carbohidratos</label>
                        <span>10 g</span>
                    </div>
                    <div className="cuadro">
                        <label>Proteína</label>
                        <span>1,5 g</span>
                    </div>
                    <div className="cuadro">
                        <label>Fibra cruda</label>
                        <span>0,6 g</span>
                    </div>
                    <div className="cuadro">
                        <label>Fósforo</label>
                        <span>26 mg</span>
                    </div>
                    <div className="cuadro">
                        <label>Vitamina A</label>
                        <span>5 ug</span>
                    </div>
                    <div className="cuadro">
                        <label>Vitamina C</label>
                        <span>25 mg</span>
                    </div>
                    <div className="cuadro">
                        <label>Niacina</label>
                        <span>0,36 mg</span>
                    </div>
                </div>
            </div>              
        {/* } */}
        <br/><br/><br/>
        {/* {this.state.showItem === 3 && */}
            <div className="main-container-product" id="">
            <div className="slider-product-container">
            <Slider {...settings}>
                <div>
                <img src={Cacao1} alt=""/>
                </div>
                <div>
                <img src={Cacao2} alt=""/>
                </div>
                <div>
                <img src={Cacao3} alt=""/>
                </div>
                <div>
                <img src={Cacao4} alt=""/>
                </div>
            </Slider>                       
            </div>
            <div className="info-product">
                <span>CACAO</span><hr/>
                <p>
                    <table>
                        <tr>
                            <th>REQUISITOS</th>
                            <th>UNIDAD</th>
                            <th>CCN-51</th>
                            <th>ASE</th>
                            <th>ASN</th>
                            <th>ASS</th>
                            <th>ASSS</th>
                            <th>ASSPS</th>
                        </tr>
                        <tr>
                            <td>100 Granos<br/>Pesan</td>
                            <td>gr</td>
                            <td>135 - 140</td>
                            <td>105 - 110</td>
                            <td>110 - 115</td>
                            <td>120 - 125</td>
                            <td>130 - 135</td>
                            <td>135 - 140</td>
                        </tr>
                        <tr>
                            <td>Buena Fermentación<br/>(Mínimo)</td>
                            <td>%</td>
                            <td>65</td>
                            <td>26</td>
                            <td>44</td>
                            <td>60</td>
                            <td>65</td>
                            <td>75</td>
                        </tr>
                        <tr>
                            <td>Ligera Fermentación<br/>(Mínimo)</td>
                            <td>%</td>
                            <td>11</td>
                            <td>27</td>
                            <td>10</td>
                            <td>5</td>
                            <td>10</td>
                            <td>10</td>
                        </tr>
                        <tr>
                            <td>Total Fermentado<br/>(Mínimo)</td>
                            <td>%</td>
                            <td>76</td>
                            <td>53</td>
                            <td>54</td>
                            <td>65</td>
                            <td>75</td>
                            <td>85</td>
                        </tr>
                        <tr>
                            <td>Violeta (Máximo)</td>
                            <td>%</td>
                            <td>18</td>
                            <td>25</td>
                            <td>25</td>
                            <td>21</td>
                            <td>15</td>
                            <td>10</td>
                        </tr>
                        <tr>
                            <td>Pizarroso / Pastoso<br/>(Máximo)</td>
                            <td>%</td>
                            <td>5</td>
                            <td>18</td>
                            <td>18</td>
                            <td>12</td>
                            <td>9</td>
                            <td>4</td>
                        </tr>
                        <tr>
                            <td>Moho (Máximo)</td>
                            <td>%</td>
                            <td>1</td>
                            <td>4</td>
                            <td>3</td>
                            <td>2</td>
                            <td>1</td>
                            <td>1</td>
                        </tr>
                        <tr>
                            <td>Totales (Análisis<br/>sobre 100 pepas)</td>
                            <td>%</td>
                            <td>100</td>
                            <td>100</td>
                            <td>100</td>
                            <td>100</td>
                            <td>100</td>
                            <td>100</td>
                        </tr>
                        <tr>
                            <td>Defectuoso (Máximo)<br/>(Análisis sobre 500gr)</td>
                            <td>%</td>
                            <td>1</td>
                            <td>4</td>
                            <td>3</td>
                            <td>1</td>
                            <td>0</td>
                            <td>0</td>
                        </tr>
                    </table><br/>
                    ASSPS: Arriba Superior Summer Plantación Selecta<br/>
                    ASSS: Arriba Superior Summer Selecto<br/>
                    ASS: Arriba Superior Selecto<br/>
                    ASN: Arriba Superior Navidad<br/>
                    ASE: Arriba Superior Época<br/>
                </p>
            </div>
        </div>    
        <div className="valor-nutricional">
                <span>VALOR <b>NUTRICIONAL</b></span><br/><br/>
                <div className="cuadros-vn">
                    <div className="cuadro">
                        <label>Calorías</label>
                        <span>500</span>
                    </div>
                    <div className="cuadro">
                        <label>Carbohidratos</label>
                        <span>45 g</span>
                    </div>
                    <div className="cuadro">
                        <label>Fibra</label>
                        <span>2 g</span>
                    </div>
                    <div className="cuadro">
                        <label>Grasas</label>
                        <span>30 g</span>
                    </div>
                    <div className="cuadro">
                        <label>Proteínas</label>
                        <span>9 g</span>
                    </div>
                    <div className="cuadro">
                        <label>Vitamina A</label>
                        <span>150 UI</span>
                    </div>
                    <div className="cuadro">
                        <label>Vitamina C</label>
                        <span>10 mg</span>
                    </div>
                    <div className="cuadro">
                        <label>Vitamina E</label>
                        <span>0,5 mg</span>
                    </div>
                </div>
            </div>           
        {/* } */}
        <br/><br/><br/><br/><br/><br/><br/>
        <div className="logos-cert">
            <span>CERTIFICACIONES</span><br/>
            {/* <img src={cert1} alt=""/> */}
            <img src={cert2} alt=""/>
            {/* <img src={cert3} alt=""/>
            <img src={cert4} alt=""/> */}
        </div>

        <Footer/>
      </div>
    );
  }
}

export default Fruit;


// WEBPACK FOOTER //
// ./src/components/en-fruit/index.js